// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import { jwtDecode } from "jwt-decode";

// const useAuthToken = () => {
//   const navigate = useNavigate();

//   useEffect(() => {
//     const checkToken = () => {
//       const token = Cookies.get("authToken");

//       if (!token) {
//         navigate("/login");
//         return;
//       }

//       const decodedToken = jwtDecode(token);
//       const currentTime = Date.now() / 1000;

//       if (decodedToken.exp < currentTime) {
//         Cookies.remove("authToken");
//         navigate("/login");
//       }
//     };

//     checkToken();

//     const handleStorageChange = () => {
//       checkToken();
//     };

//     window.addEventListener("storage", handleStorageChange);
//     return () => {
//       window.removeEventListener("storage", handleStorageChange);
//     };
//   }, [navigate]);

//   return !!Cookies.get("authToken");
// };

// export default useAuthToken;

import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { useNavigate, useLocation } from "react-router-dom";

const useAuthToken = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkToken = () => {
      const token = Cookies.get("authToken");

      if (!token) {
        setIsAuthenticated(false);
        return;
      }

      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decodedToken.exp < currentTime) {
          Cookies.remove("authToken");
          setIsAuthenticated(false);
        } else {
          setIsAuthenticated(true);

          // Navigate to home page only if the user is on the login page
          if (location.pathname === "/login") {
            navigate("/");
          }
        }
      } catch (error) {
        Cookies.remove("authToken");
        setIsAuthenticated(false);
      }
    };

    checkToken();
  }, [navigate, location.pathname]);

  return isAuthenticated; // Returns true, false, or null (loading)
};

export default useAuthToken;
